import {svgIconWrapper} from '../svg-icon-wrapper';

import BusinessCardRegular from './business-card-regular-icon.svg';

// @ts-expect-error
function SvgComponent(props) {
    const validProps = Object.assign({}, props);
    delete validProps.styles;

    return <BusinessCardRegular {...validProps} />;
}
SvgComponent.iconName = 'businessCardRegular';

export const BusinessCardRegularIcon = svgIconWrapper(SvgComponent);
